// src/components/Navbar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // "supper" | "recipes" | "shop" | null

  const toggleDropdown = (key) =>
    setOpenDropdown(openDropdown === key ? null : key);

  return (
    <nav className="navbar">
      <div className="container flex-between">
        {/* ------------ Logo ------------ */}
        <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
          <h1>Foodea</h1>
        </Link>

        {/* ------------ Burger (mobile) ------------ */}
        <button
          className="menu-icon"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>

        {/* ------------ Main links ------------ */}
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>

          {/* Supper Club dropdown */}
          {/*<li className="has-drop">
            <button
              type="button"
              className="drop-toggle"
              aria-expanded={openDropdown === "supper"}
              onClick={() => toggleDropdown("supper")}
            >
              Supper&nbsp;Club
            </button>
            <ul className={`dropdown ${openDropdown === "supper" ? "show" : ""}`}>
              <li>
                <Link to="/supper/summer" onClick={() => setMenuOpen(false)}>
                  Summer Menu
                </Link>
              </li>
              <li>
                <Link to="/supper/spring" onClick={() => setMenuOpen(false)}>
                  Spring Menu
                </Link>
              </li>
              <li>
                <Link to="/supper/movie-night" onClick={() => setMenuOpen(false)}>
                  Movie Night
                </Link>
              </li>
              <li>
                <Link to="/supper/vegetarian" onClick={() => setMenuOpen(false)}>
                  Vegetarian Menu
                </Link>
              </li>
            </ul>
  </li>*/}

          {/* Recipes dropdown */}
        {/*  <li className="has-drop">
            <button
              type="button"
              className="drop-toggle"
              aria-expanded={openDropdown === "recipes"}
              onClick={() => toggleDropdown("recipes")}
            >
              Recipes
            </button>
            <ul className={`dropdown ${openDropdown === "recipes" ? "show" : ""}`}>
              <li>
                <Link to="/recipes/vegetarian" onClick={() => setMenuOpen(false)}>
                  Vegetarian
                </Link>
              </li>
              <li>
                <Link to="/recipes/desserts" onClick={() => setMenuOpen(false)}>
                  Desserts
                </Link>
              </li>
              <li>
                <Link to="/recipes/pasta" onClick={() => setMenuOpen(false)}>
                  Pasta
                </Link>
              </li>
              <li>
                <Link to="/recipes/pizza" onClick={() => setMenuOpen(false)}>
                  Pizza
                </Link>
              </li>
              <li>
                <Link to="/recipes/burger" onClick={() => setMenuOpen(false)}>
                  Burger
                </Link>
              </li>
              <li>
                <Link to="/recipes/salad" onClick={() => setMenuOpen(false)}>
                  Salad
                </Link>
              </li>
              <li>
                <Link to="/recipes/chicken" onClick={() => setMenuOpen(false)}>
                  Chicken
                </Link>
              </li>
              <li>
                <Link to="/recipes/meat" onClick={() => setMenuOpen(false)}>
                  Meat
                </Link>
              </li>
              <li>
                <Link to="/recipes/fish" onClick={() => setMenuOpen(false)}>
                  Fish
                </Link>
              </li>
            </ul>
</li>*/}

          {/* Shop dropdown */}
          {/*<li className="has-drop">
            <button
              type="button"
              className="drop-toggle"
              aria-expanded={openDropdown === "shop"}
              onClick={() => toggleDropdown("shop")}
            >
              Shop
            </button>
            <ul className={`dropdown ${openDropdown === "shop" ? "show" : ""}`}>
              <li>
                <Link to="/shop" onClick={() => setMenuOpen(false)}>
                  All
                </Link>
              </li>
              <li>
                <Link to="/shop/decor" onClick={() => setMenuOpen(false)}>
                  Decor
                </Link>
              </li>
              <li>
                <Link to="/shop/tableware" onClick={() => setMenuOpen(false)}>
                  Tableware
                </Link>
              </li>
              <li>
                <Link to="/shop/gifts" onClick={() => setMenuOpen(false)}>
                  Gifts&nbsp;&amp;&nbsp;Kits
                </Link>
              </li>
              <li>
                <Link to="/shop/art-prints" onClick={() => setMenuOpen(false)}>
                  Art&nbsp;&amp;&nbsp;Prints
                </Link>
              </li>
              <li>
                <Link to="/shop/book" onClick={() => setMenuOpen(false)}>
                  Book
                </Link>
              </li>
            </ul>
</li>*/}

          <li>
            <Link to="/about" onClick={() => setMenuOpen(false)}>
              About
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>

        {/* ------------ Search ------------ */}
        <button className="search-icon" aria-label="Search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </button>
      </div>

      {/* ------------ Styles ------------ */}
      <style jsx>{`
        /* --- Layout & wrapper --- */
        .navbar {
          padding: 1.5rem 0;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          position: sticky;
          top: 0;
          background: var(--white);
          z-index: 1000;
        }

        /* --- Logo --- */
        .logo h1 {
          font-family: "Playfair Display", serif;
          font-weight: 700;
          font-size: 2rem;
          color: var(--primary-color);
          margin: 0;
        }

        /* --- Main list --- */
        .nav-links {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          align-items: center;
        }

        .nav-links li {
          margin: 0 1.2rem;
          position: relative;
        }

        .nav-links a,
        .drop-toggle {
          color: var(--dark-color);
          font-family: inherit;
          font-weight: 500;
          font-size: 1rem;
          background: none;
          border: none;
          cursor: pointer;
          transition: color 0.3s ease;
          padding: 0;
        }

        .nav-links a:hover,
        .drop-toggle:hover {
          color: var(--primary-color);
        }

        /* --- Dropdown --- */
        .dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          display: none;
          flex-direction: column;
          min-width: 160px;
          background: var(--white);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
          padding: 0.8rem 1rem;
          list-style: none;
          z-index: 1000;
        }

        .dropdown li {
          margin: 0.4rem 0;
        }

        .dropdown.show {
          display: flex;
        }

        /* Masaüstünde hover ile açılma */
        @media (min-width: 769px) {
          .has-drop:hover > .dropdown {
            display: flex;
          }
          .drop-toggle {
            pointer-events: none;
          }
        }

        /* --- Mobile --- */
        .menu-icon {
          display: none;
          flex-direction: column;
          gap: 4px;
          background: none;
          border: none;
          cursor: pointer;
        }

        .menu-icon span {
          width: 25px;
          height: 3px;
          background-color: var(--dark-color);
          transition: all 0.3s ease;
        }

        @media (max-width: 768px) {
          .menu-icon {
            display: flex;
          }

          .nav-links {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background: var(--white);
            flex-direction: column;
            padding: 2rem;
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
            display: none;
          }

          .nav-links.active {
            display: flex;
          }

          .nav-links li {
            margin: 1rem 0;
          }

          .dropdown {
            position: static;
            box-shadow: none;
            padding-left: 1rem;
          }
        }

        /* --- Search icon --- */
        .search-icon {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          display: flex;
          align-items: center;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
